import React from 'react';
import { motion } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
export function Step11Content() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-49">
      <MascotPanel message="Content is king! Een website heeft teksten en beeldmateriaal nodig. Hoe wilt u dit aanpakken?" data-id="element-50" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-51">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-52">
          Content & Beeldmateriaal
        </h2>

        <div data-id="element-53">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-54">
            Hoe wilt u de teksten voor de website regelen?
          </label>
          <RadioGroup columns={1} value={data.existingContent[0] || ''} onChange={val => updateData({
          existingContent: [val]
        })} options={[{
          value: 'write_all',
          label: 'Noord Digital schrijft alles (Aanbevolen)',
          description: 'Professionele, SEO-geoptimaliseerde teksten'
        }, {
          value: 'rewrite',
          label: 'Ik lever teksten aan, Noord Digital redigeert',
          description: 'Wij maken uw teksten web-klaar'
        }, {
          value: 'self',
          label: 'Ik schrijf en lever alle teksten zelf aan',
          description: 'U bent zelf verantwoordelijk voor de inhoud'
        }]} data-id="element-55" />
        </div>

        <div data-id="element-56">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-57">
            Hoe zit het met fotografie en beeldmateriaal?
          </label>
          <RadioGroup columns={1} value={data.createContent[0] || ''} onChange={val => updateData({
          createContent: [val]
        })} options={[{
          value: 'have_photos',
          label: "Ik heb professionele foto's beschikbaar"
        }, {
          value: 'need_shoot',
          label: 'Ik wil graag een fotoshoot inplannen via Noord Digital'
        }, {
          value: 'stock',
          label: 'Gebruik (premium) stockfotografie'
        }]} data-id="element-58" />

          <div className="mt-4 p-4 bg-blue-50 border border-blue-100 rounded-xl text-sm text-blue-800" data-id="element-59">
            <strong data-id="element-60">Let op:</strong> Noord Digital neemt contact met u op over
            de specifieke wensen rondom fotografie en beeldmateriaal.
          </div>
        </div>

        <div className="pt-6 border-t border-gray-100" data-id="element-61">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-62">
            Welke toon moet de website hebben?
          </label>
          <RadioGroup columns={2} value={data.toneOfVoice} onChange={val => updateData({
          toneOfVoice: val
        })} options={[{
          value: 'formal',
          label: 'Formeel (u-vorm, zakelijk)'
        }, {
          value: 'informal',
          label: 'Informeel (je-vorm, toegankelijk)'
        }, {
          value: 'mix',
          label: 'Mix (je-vorm maar wel professioneel)'
        }, {
          value: 'advise',
          label: 'Weet ik niet, adviseer mij'
        }]} data-id="element-63" />
        </div>
      </div>
    </motion.div>;
}